import { render, staticRenderFns } from "./LogoCtc.vue?vue&type=template&id=66f845a2&scoped=true"
import script from "./LogoCtc.vue?vue&type=script&lang=js"
export * from "./LogoCtc.vue?vue&type=script&lang=js"
import style0 from "./LogoCtc.vue?vue&type=style&index=0&id=66f845a2&prod&lang=scss&scoped=true"
import style1 from "./LogoCtc.vue?vue&type=style&index=1&id=66f845a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f845a2",
  null
  
)

export default component.exports